import React from 'react';
import t from '~t';
import { useSelector, useDispatch } from 'react-redux';
import { set } from '~data/actions/config';

import { Label, Checkbox } from '~ui';

export default function SettingsAppRaindropsSearchByScore() {
  const raindrops_search_by_score = useSelector(
    (state) => state.config.raindrops_search_by_score,
  );
  const dispatch = useDispatch();

  return (
    <>
      <Label>{t.s('defaultCollection-0')}</Label>
      <div>
        <Checkbox
          checked={raindrops_search_by_score}
          onChange={() =>
            dispatch(
              set('raindrops_search_by_score', !raindrops_search_by_score),
            )
          }
        >
          {t.s('sortByRelevance')}
        </Checkbox>
      </div>
    </>
  );
}
